/**
 * Pantalla de acceso, para cuando la aplicacion corre servida desde la web.
 *
 * Se pide una clave, no un correo y una contraseña: esto lo abre una familia,
 * y obligar a cada tio y cada prima a crearse una cuenta para mirar un arbol
 * es pedir demasiado a cambio de nada. Hay dos claves, la que edita y la que
 * solo mira, y el servidor decide cual es cual.
 */
import { el, vaciar } from "../ui/dom.js";
import type { Nube, Rol } from "./cliente.js";

export interface OpcionesAcceso {
  nube: Nube;
  /** Se llama cuando se entra bien. */
  alEntrar(rol: Rol): void;
}

export function pantallaAcceso(op: OpcionesAcceso): HTMLElement {
  const fondo = el("div", { clase: "acceso" });
  const caja = el("div", { clase: "acceso-caja" });

  caja.appendChild(el("h1", { texto: "Árbol familiar" }));
  caja.appendChild(
    el("p", {
      clase: "acceso-sub",
      texto: op.nube.estado.lectura
        ? "Escribe tu clave. Según cuál sea, podrás editar el árbol o solo mirarlo."
        : "Escribe la clave para entrar.",
    }),
  );

  const campo = el("input");
  campo.type = "password";
  campo.placeholder = "Clave";
  campo.autocomplete = "current-password";
  campo.setAttribute("aria-label", "Clave");

  const aviso = el("div", { clase: "acceso-error" });
  const boton = el("button", { clase: "primario", texto: "Entrar" });

  const intentar = async (): Promise<void> => {
    const clave = campo.value;
    if (!clave) {
      aviso.textContent = "Escribe la clave.";
      return;
    }
    boton.disabled = true;
    campo.disabled = true;
    aviso.textContent = "";
    boton.textContent = "Comprobando…";
    try {
      const rol = await op.nube.entrar(clave);
      op.alEntrar(rol);
    } catch (e) {
      aviso.textContent = e instanceof Error ? e.message : "No se pudo entrar.";
      boton.disabled = false;
      campo.disabled = false;
      boton.textContent = "Entrar";
      campo.select();
    }
  };

  boton.addEventListener("click", () => void intentar());
  campo.addEventListener("keydown", (ev) => {
    if (ev.key === "Enter") void intentar();
  });

  caja.appendChild(campo);
  caja.appendChild(aviso);
  caja.appendChild(boton);

  if (!op.nube.estado.configurado) {
    vaciar(aviso);
    caja.appendChild(
      el("p", {
        clase: "acceso-nota",
        texto:
          "El servidor todavía no tiene configurados sus secretos, así que " +
          "no se puede entrar. Revisa docs/WEB.md.",
      }),
    );
    boton.disabled = true;
    campo.disabled = true;
  }

  fondo.appendChild(caja);
  // El foco va al campo en cuanto aparece, para poder escribir sin tocar nada.
  setTimeout(() => campo.focus(), 50);
  return fondo;
}
